document.addEventListener('DOMContentLoaded', () => {
  const WISHLIST_KEY = 'shopify-wishlist';

  const getWishlist = () => {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  };

  const setWishlist = (ids) => {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
  };

  const toggleWishlist = (productId) => {
    let list = getWishlist();
    if (list.includes(productId)) {
      list = list.filter(id => id !== productId);
    } else {
      list.push(productId);
    }
    setWishlist(list);
    updateIcons();
  };

  const isWishlisted = (productId) => {
    return getWishlist().includes(productId);
  };

  const updateIcons = () => {
    document.querySelectorAll('[data-wishlist-button]').forEach(btn => {
      const productId = btn.getAttribute('data-product-id');
      const filled = btn.querySelector('.filled');
      if (isWishlisted(productId)) {
        filled?.classList.remove('hidden');
      } else {
        filled?.classList.add('hidden');
      }
    });
  };

  document.body.addEventListener('click', e => {
    const btn = e.target.closest('[data-wishlist-button]');
    if (!btn) return;
    e.preventDefault();
    toggleWishlist(btn.getAttribute('data-product-id'));
  });

  updateIcons();
});
